export * from "./ConsumablesProductDetails";
